angular.module 'zc.master'

.controller 'MasterAgenciesCtrl', ($scope, $translate, Page, agencies) ->

  Page.setBodyClass ''
  $translate('masterAgencies.list.agenciesList').then (translation) ->
    Page.setTitle translation

  $scope.agencies = agencies



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.agencies/list.controller.coffee